import axios from 'axios';
import config from '@app2/api/config';
import eventBus from '@app2/core/eventBus';
import get from 'lodash/get';

// START: DUMMY DATA INTERCEPTOR (FOR TESTING ONLY)
// import dummyGetTotalMembers from '@app2/core/Components/Analytics/DummyData/getTotalMembers.json';
// import dummyGetTotalActiveMembers from '@app2/core/Components/Analytics/DummyData/getTotalActiveMembers.json';
// import dummyGetDailyNewUsers from '@app2/core/Components/Analytics/DummyData/getDailyNewUsers.json';
// import dummyGetRecentMembers from '@app2/core/Components/Analytics/DummyData/getRecentMembers.json';
// import dummyGetJoinedEarlier from '@app2/core/Components/Analytics/DummyData/getJoinedEarlier.json';
// import dummyGetDailyNewPosts from '@app2/core/Components/Analytics/DummyData/getDailyNewPosts.json';
// import dummyGetDailyNewComments from '@app2/core/Components/Analytics/DummyData/getDailyNewComments.json';
// import dummyGetTopPosts from '@app2/core/Components/Analytics/DummyData/getTopPosts.json';
// import dummyGetTopAchievements from '@app2/core/Components/Analytics/DummyData/getTopAchievements.json';
// import dummyGetTopSpaces from '@app2/core/Components/Analytics/DummyData/getTopSpaces.json';
// import dummyGetTopMembersByComments from '@app2/core/Components/Analytics/DummyData/getTopMembersByComments.json';
// import dummyGetTopMembersByPosts from '@app2/core/Components/Analytics/DummyData/getTopMembersByPosts.json';
// import dummyGetPopularFiles from '@app2/core/Components/Analytics/DummyData/getPopularFiles.json';
// import dummyGetPopularPlaylists from '@app2/core/Components/Analytics/DummyData/getPopularPlaylists.json';
// import dummyGetDailyWisdomFeedback from '@app2/core/Components/Analytics/DummyData/getDailyWisdomFeedback.json';
// import dummyGetLatestConversations from '@app2/core/Components/Analytics/DummyData/getLatestConversations.json';
// END: DUMMY DATA INTERCEPTOR (FOR TESTING ONLY)

const instance = axios.create(config(axios));

// instance.interceptors.request.use(
//   async (config) => {
//     for (const entry of DUMMY_DATA_CONFIG) {
//       if (entry.regex.test(config.url)) {
//         console.warn(`[DUMMY DATA] Intercepting: ${config.url}`);
//         return Promise.resolve({
//           ...config,
//           adapter: () => Promise.resolve({
//             data: entry.data,
//             status: 200,
//             statusText: 'OK (DUMMY DATA)',
//             headers: { 'content-type': 'application/json' },
//             config: config,
//             request: null,
//           }),
//         });
//       }
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );
// END: DUMMY DATA INTERCEPTOR (FOR TESTING ONLY)

/**
 * Interceptors for responses that return tokens
 * Format expires_in (seconds) to an expiration date before passing it to the application
 */
instance.interceptors.response.use(
  res => res,
  error => {
    if (axios.isCancel(error)) throw error;
    const { status } = (error && error.response) || { status: 500 };
    // Handle Session Timeouts / Logged out
    if (status === 401 && !get(error, 'response.config.url', '').includes('chat/token')) {
      eventBus.$emit('auth/unauthenticated');
    }
    throw error.response || { data: { message: error.message || 'Something went wrong.' } };
  }
);

export default instance;
